export function uint8ArrayToBlob(
  data: Uint8Array,
  mimeType = 'application/octet-stream'
): Blob {
  const blobSafeBytes = new Uint8Array(data.byteLength);
  blobSafeBytes.set(data);
  return new Blob([blobSafeBytes.buffer], { type: mimeType });
}

export function concatUint8Arrays(chunks: Uint8Array[]): Uint8Array {
  const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
  const result = new Uint8Array(totalLength);

  let offset = 0;
  for (const chunk of chunks) {
    result.set(chunk, offset);
    offset += chunk.length;
  }

  return result;
}
